import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem, Highlight, Icon } from '@node-space/ui-components'
import { useMinutesSecondsTimer } from 'hooks/useMinutesSecondsTimer'
import { Quote } from 'types/payments'
import { useCountdownRestart } from '../hooks/useCountdownRestart'

interface QuoteCountdownProps {
  quote: Quote
  isRefreshingQuote: boolean
  onExpire: () => void
}

export const QuoteCountdown = ({ quote, isRefreshingQuote, onExpire }: QuoteCountdownProps) => {
  const { t } = useTranslation()

  const totalExpiry = useMemo(
    () =>
      Math.max(
        0,
        Math.round((new Date(quote?.acceptanceExpiryDate).getTime() - Date.now()) / 1000)
      ),
    [quote?.acceptanceExpiryDate]
  )

  const { formattedTime, timeLeft, resetTimer } = useMinutesSecondsTimer(
    0,
    totalExpiry,
    true,
    onExpire
  )

  useCountdownRestart({
    resetTimer,
    timeLeft,
    quote,
  })

  return (
    <DataListItem
      id="quote-expires-in"
      title={t('wallets.convert.quoteExpiresIn')}
      body=""
      size="large"
      HeaderHighlight={
        isRefreshingQuote ? (
          <Highlight
            variant="emphasis"
            type="warning"
            iconElement={
              <Box className="animate-spin">
                <Icon name="Spinner" />
              </Box>
            }
          >
            {t('requestingNewQuote')}
          </Highlight>
        ) : (
          <Highlight
            variant="emphasis"
            type="warning"
          >{`${formattedTime?.minutes}:${formattedTime?.seconds}`}</Highlight>
        )
      }
    />
  )
}
